:host {
  display: inline-block;
}